import { useContext } from "react";
import { EditActionContext } from "./EditActionContext";
import { ChangeDectionContext } from "@beeldit/core/context/ChangeDectionContext";

function useInitialize() {
  const { setElement, setBackendFormErrors } = useContext(EditActionContext);
  const { setChanged } = useContext(ChangeDectionContext);
  return () => {
    let initilizeData = { pets: [{ name: "" }] };
    // Si la variable de entorno REACT_APP_ACTIVATE_MOCKS está activada se inicializa el formulario con los datos de la carpeta ../../mocks/initialize.json
    // if (process.env.REACT_APP_ACTIVATE_MOCKS === "true") {
    //   initilizeData = require("../../mocks/initialize.json");
    // }
    setElement(initilizeData);
    setBackendFormErrors({});
    setTimeout(() => {
      setChanged(false, initilizeData);
    }, 3000);
  };
}

export default useInitialize;
